<template>
    <div
        class="notice"
        :class="noticeClass()"
        role="status"
    >
        <div
            v-if="header"
            class="notice__title"
        >
            {{ header }}
        </div>
        <p
            v-if="message"
            :class="{ 'no-margin-top': !header }"
        >
            {{ message }}
        </p>
        <p v-if="secondaryMessage">
            {{ secondaryMessage }}
        </p>
    </div>
</template>

<style lang="css" scoped src="../../node_modules/@servicensw/notice/dist/notice.css"></style>
<style scoped lang="scss">
    .notice {
        margin-bottom: 2rem;

        p {
            margin: 1.5rem 0;
            max-width: 769px;

            &.no-margin-top {
                margin-top: 0;
            }
        }
    }
</style>

<script>
    export default {
        name: 'Notice',
        props: {
            header: {
                type: String,
                default: ''
            },
            message: {
                type: String,
                default: ''
            },
            secondaryMessage: {
                type: String,
                default: ''
            },
            noticeType: {
                type: String,
                default: ''
            }
        },
        methods: {
            noticeClass () {
                switch (this.noticeType) {
                    case 'WARNING':
                        return 'notice--warning'
                    case 'ERROR':
                        return 'notice--error'
                    case 'SUCCESS':
                        return 'notice--success'
                }
            }
        }
    }
</script>
